/**
 * i18n Constants and Utilities
 * Separated from useTranslation.jsx to avoid Fast Refresh warnings
 */

import { detectUserLanguageWithIPFallback } from "./geolocation.js";
import { en, pt } from "./translations.js";

// Available languages
export const LANGUAGES = {
  en: { code: "en", name: "English", flag: "🇺🇸" },
  pt: { code: "pt", name: "Português", flag: "🇧🇷" },
};

/**
 * Language detection utilities
 * @returns {Promise<string>} Detected language code
 */
export const detectUserLanguage = async () => {
  // Use enhanced detection with IP fallback
  return await detectUserLanguageWithIPFallback();
};

/**
 * Get translation object for a language
 * @param {string} language - Language code
 * @returns {Object} Translation object
 */
export const getTranslation = (language) => {
  switch (language) {
    case "pt":
      return pt;
    case "en":
    default:
      return en;
  }
};
